import { tooltip } from './_base';

const Water = () => {
  let value = 0;

  return {
    value,
    label: 'Water',
    isCarried: true,
    tooltip: gameState => tooltip('water', gameState),
    min: 0
  };
};

export default Water;
